var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseStepper',{staticClass:"my-1",attrs:{"steps":_vm.steps}}),_c('QuoteErrorAlert',{staticClass:"mx-3 mx-xl-0",attrs:{"isQuotationStage":false}}),_c('div',{staticClass:"white rounded-lg elevation-3 ma-3 pa-3 pa-lg-8"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }